import cloneDeep from 'lodash/cloneDeep'
import PeriodMapper from '@/services/mapper/PeriodMapper'

class CompanyAllowancesFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        // days
        if (entity.days) {
            entity.days = PeriodMapper.toEntity(entity.days)
        }

        // the unique id is not shown any more (user decision 2026-11-04, tasks#211), but the column is
        // required and the legacy employee CSV import matches budgets by it (`ordering_rule_id`): a new
        // budget gets one from its name, an existing one keeps its stored id
        if (!entity.uniqueId) {
            entity.uniqueId = uniqueIdFromName(entity.name)
        }

        return entity
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)

        // groupAllowedEmployees
        if (values.groupAllowedEmployees) {
            values.groupAllowedEmployees = values.groupAllowedEmployees.map(
                (item) => item['@id']
            )
        }

        // days
        if (values.days && Array.isArray(values.days)) {
            values.days = PeriodMapper.fromEntity(values.days)
        }

        if (values.intervalStart) {
            values.intervalStart = values.intervalStart.substr(0, 10)
        }

        return values
    }
}

// "Lunch budget (UK)" -> "lunch_budget_uk"; the column holds 255 characters
function uniqueIdFromName(name) {
    const slug = String(name || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .slice(0, 255)
    return slug || 'budget'
}

export default new CompanyAllowancesFormMapper()
